import React from 'react';
import '../pages-style/about.css';

const AboutUs = () => {
  return (
    <div className="about-us">
      <div className="container">
        <header className="App-heading">
          <h1>About Us</h1>
        </header>

        <section id="intro">
          <h2>Welcome to our Laravel Tutorial Website!</h2>
          <p>
            We are passionate about helping developers of all levels learn and grow their skills in Laravel, one of the most popular PHP frameworks in the web development world. 
            Whether you're a beginner looking to build your first project or an experienced developer seeking advanced tips and techniques, you're in the right place.
          </p>
        </section>

        <section id="what-we-do">
          <h2>What We Do</h2>
          <p>
            Our mission is to provide easy-to-follow, comprehensive Laravel tutorials, guides, and resources. From setting up a Laravel project to mastering advanced features like Eloquent ORM, Blade templates, and API development, we cover everything you need to become proficient in Laravel.
          </p>
          <p>
            We believe in the power of learning by doing, so many of our tutorials come with real-world examples and step-by-step instructions. Our goal is to help you confidently create robust web applications using Laravel, with a focus on best practices and modern web standards.
          </p>
        </section>

        <section id="why-choose-us">
          <h2>Why Choose Us?</h2>
          <ul>
            <li><strong>Detailed Guides:</strong> We break down complex topics into manageable pieces, making sure you understand every step.</li>
            <li><strong>Real-World Examples:</strong> Learn by building actual projects and solving real-world challenges.</li>
            <li><strong>Community Support:</strong> We’re more than just a website – we’re a community. Feel free to engage with us through comments, ask questions, and share your experiences.</li>
            <li><strong>Up-to-Date Content:</strong> The world of web development is always evolving, and we strive to keep our tutorials up-to-date with the latest Laravel releases and features.</li>
          </ul>
        </section>

        <section id="join-us">
          <h2>Join Us</h2>
          <p>
            Stay connected with us for the latest Laravel updates, tips, and tutorials. Subscribe to our website, follow us on social media, and embark on your Laravel development journey with us.
          </p>
        </section>

        <footer>
          <p>Thank you for visiting, and happy coding!</p>
        </footer>
      </div>
    </div>
  );
};

export default AboutUs;
